import React from "react";
import { Button } from "react-bootstrap";

interface Props {
    currentPage: number;
    setCurrentPage: (page: number) => void;
}

const PostButtons = ({ currentPage, setCurrentPage }: Props) => {
    console.log(`${currentPage} dupa2`)

    return (
        <div className="PostBtn">
            <Button className="Btn" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
                « Previous
            </Button>
            <Button
                className="Btn Btn-2"
                onClick={() => setCurrentPage(currentPage + 1)}
            >
                Next »
            </Button>
        </div>
    );
};

export default PostButtons;